import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Block } from '../../abstract/Block.js';
export class Select extends Block {
  constructor() {
    super(...arguments);
    _defineProperty(this, "init$", _objectSpread(_objectSpread({}, this.init$), {}, {
      currentText: '',
      options: [],
      selectHtml: '',
      onSelect: e => {
        var _this$$$options$find;
        e.preventDefault();
        e.stopPropagation();
        this.value = this.ref.select.value;
        this.$.currentText = ((_this$$$options$find = this.$.options.find(opt => {
          return opt.value == this.value;
        })) === null || _this$$$options$find === void 0 ? void 0 : _this$$$options$find.text) || '';
        this.dispatchEvent(new Event('change'));
      }
    }));
  }
  initCallback() {
    super.initCallback();
    this.sub('options', (/** @type {{ text: String; value: String }[]} */options) => {
      var _options$;
      this.$.currentText = (options === null || options === void 0 || (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.text) || '';
      let html = '';
      options === null || options === void 0 || options.forEach(opt => {
        html += /* HTML */"<option value=\"".concat(opt.value, "\">").concat(opt.text, "</option>");
      });
      this.$.selectHtml = html;
    });
  }
}
Select.template = /* HTML */"\n  <button>\n    {{currentText}}\n    <lr-icon name=\"select\"></lr-icon>\n    <select ref=\"select\" set=\"innerHTML: selectHtml; onchange: onSelect\"></select>\n  </button>\n";